<template>
    <div>
      
         <main class="main">
            <div class="bredcumb">
                <div class="container">
                    <ul>
                        <li><router-link to="/index"><a href="/index">首頁</a></router-link></li>
                        <li>品牌故事</li>
                    </ul>
                </div>
            </div>

            <!--品牌故事開始-->
            <div class="brand_head">
                <div class="container">
                    <div class="wrapper">
                        <h1 class="wow fadeInUp">品牌精神</h1>
                        <p class="wow fadeInUp">被光包覆著，眼睛看到世界的多彩與意象</p>
                        <p class="marginB_1 wow fadeInUp">也被聲波所包覆，在時間裏，耳朵感受到世界的心跳</p>
                        <p class="wow fadeInUp">手機是我身體的一部份，是我感受的延伸</p>
                        <p class="wow fadeInUp">我的生活零碎但必須精采，</p>
                        <p class="wow fadeInUp">一刻 15 分鐘的音頻，像晶瑩的氧氣氣泡，閃綴起海洋中的知識藍圖</p>
                        
                    </div>
                </div>
                <div class="image"><img src="@/assets/images/graphic_ocean.jpg" alt=""></div>
            </div>

            <div class="bodyContent">
                <div class="container">
                    <section class="aboutJin">
                        <h2>關於鯨</h2>
                        <div>
                            <ul class="iconWithIntro">
                                <li class="wow fadeInUp">
                                    <div class="decoImg"><img src="@/assets/images/deco_jin_01.png" alt="" /></div>
                                    <p>多采浩瀚汪洋中，從海面至下探1,000公尺深海裡，牠們始終怡然悠游其中，聽力是牠最為靈敏的感官，透過聲納與夥伴相互溝通，讓牠們在一片漆黑的深洋中，得以彼此聯繫並建構族群。</p>
                                    <p>聲音的傳遞，打破了視界，齒鯨類最巨大的動物，以聽覺，作為生命中最靈魂的主軸，牠們是，你我所熟識的海洋珍寶，抹香鯨。</p>
                                </li>
                                <li class="wow fadeInUp">
                                    <div class="decoImg"><img src="@/assets/images/deco_jin_02.png" alt="" /></div>
                                    <p>「一刻鯨選」，一刻意為15分鐘，是現代人專注吸收的極限時間，</p>
                                    <p>鯨，貫注了品牌核心靈魂，擁有高度聽力的抹香鯨，聲音在海中可以傳達到數十公里遠，就像用回聲定位尋找知識；</p>
                                    <p>用一刻時間，打開耳朵，投入知識海洋，就從這一刻開始，讓零碎時間變得更加充實，聆聽名家多元類型精選課程，</p>
                                    <p>「一刻鯨選」真摯與你分享！</p>
                                </li>
                            </ul>
                        </div>
                    </section>
                    
                </div>
            </div>

            <!--品牌故事結束-->


        </main>
       
    </div>    
</template>

<script>
export default {
    name: 'async',
    metaInfo () {
      return {
        title: '品牌故事 | 一刻鯨選',
        meta: [
            // OpenGraph data (Most widely used)
            {property: 'og:title', content: '品牌故事 | 一刻鯨選'},
            {property: 'og:site_name', content: '品牌故事 | 一刻鯨選'},
            // The list of types is available here: http://ogp.me/#types
            {property: 'og:type', content: 'website'},
            // Should the the same as your canonical link, see below.
            {property: 'og:url', content: window.location.toString()},
            // {property: 'og:image', content: '/static/logo.png'},
            // Often the same as your meta description, but not always.
            {property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！'},
        
        ]
      }
    },
    
 data() {
    return {
       classData: [],
    }
  },
   methods: {
       

        changePage(page){
        this.$router.push({ path: "/"+page});

        }

　　},
    mounted() {
        $( "body" ).removeClass('index');
      }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/BrandStory.vue